/****************************************************
 * Module Name:  addShapeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Checkbox, FormControlLabel } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddShapeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newshape: this.props.editOperation ? this.props.sourceData.name : "",
      newshapefullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",
      newimage: this.props.editOperation ? this.props.sourceData.image : "",
      newpacketimage1: this.props.editOperation ? this.props.sourceData.packetimage1 : "",
      newpacketimage2: this.props.editOperation ? this.props.sourceData.packetimage2 : "",
      newpacketimage3: this.props.editOperation ? this.props.sourceData.packetimage3 : "",
      newdisabled: this.props.editOperation ? this.props.sourceData.disabled : false,

      changingImage: false,
      changingPacketImage1: false,
      changingPacketImage2: false,
      changingPacketImage3: false,

      showError: false,

      validateShapePresentSpinner: false,
      showValidationMessage: false,
      shapeAvailable: true,

      shapeValidationError: "",
      fullNameValidationError: "",
    };
  }

  convertByteToFile = (byte) => {
    // Convert base64 to raw binary data
    const base64String = byte.replace(/^data:[^;]+;base64,/, '');

    // Convert base64 to raw binary data
    const byteCharacters = atob(base64String);

    // Convert binary data to array buffer
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'image/svg+xml' });
    const file = new File([blob], "image.svg+xml", { type: 'image/svg+xml' });
    return file;
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newshape,
      fullname: this.state.newshapefullname,
      description: this.state.newdescription,
      disabled: this.state.newdisabled,
      seq: this.state.newseq
    };

    let formData = new FormData();

    this.state.newimage !== this.props.sourceData.image ? formData.append("file", this.state.newimage) :
      (this.state.newimage === null ? formData.append("file", null) : formData.append("file", this.convertByteToFile(this.state.newimage)));
    this.state.newpacketimage1 !== this.props.sourceData.packetimage1 ? formData.append("packetimage1", this.state.newpacketimage1) :
      (this.state.newpacketimage1 === null ? formData.append("file", null) : formData.append("packetimage1", this.convertByteToFile(this.state.newpacketimage1)));
    this.state.newpacketimage2 !== this.props.sourceData.packetimage2 ? formData.append("packetimage2", this.state.newpacketimage2) :
      this.state.newpacketimage2 === null ? formData.append("file", null) : formData.append("packetimage2", this.convertByteToFile(this.state.newpacketimage2));
    this.state.newpacketimage3 !== this.props.sourceData.packetimage3 ? formData.append("packetimage3", this.state.newpacketimage3) :
      this.state.newpacketimage3 === null ? formData.append("file", null) : formData.append("packetimage3", this.convertByteToFile(this.state.newpacketimage3));

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data, formData))
          this.props.handleSave(data, formData);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data, formData);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateShapePresent = (shapeEntered) => {
    if (!shapeEntered || shapeEntered.trim() === "") return;

    this.setState({
      validateShapePresentSpinner: true,
    });

    ShapeProxy.CheckShapeAvailable(shapeEntered, (response) => {
      //if we got response that means shape is present at backend
      if (response) {
        //ShapeName already present
        this.setState({
          validateShapePresentSpinner: false,
          showValidationMessage: true,
          shapeAvailable: false,
        });
      } else {
        //ShapeName not available, so can be used
        this.setState({
          validateShapePresentSpinner: false,
          showValidationMessage: true,
          shapeAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newshapefullname.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.shapeAvailable ||
        this.state.newshapefullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add shape validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Shape" : "Add New Shape"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Shape Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Shape <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newshape}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Shape (required)"
                          placeholder="Enter Shape"
                          value={this.state.newshape}
                          autoFocus
                          onBlur={(e) =>
                            this.validateShapePresent(this.state.newshape)
                          }
                          onChange={(e) =>
                            this.setState({
                              newshape: e.target.value,
                              showValidationMessage: false,
                              shapeValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Shape Cannot be Empty",
                            })
                          }
                          helperText={this.state.shapeValidationError}
                          error={this.state.shapeValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateShapePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.shapeAvailable ? (
                        <font color="green">Shape available</font>
                      ) : (
                        <font color="red">Shape not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Shape Fullname</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Shape Fullname"
                        placeholder="Enter Shape Fullname"
                        value={this.state.newshapefullname}
                        onChange={(e) =>
                          this.setState({
                            newshapefullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Shape Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Disabled</Form.Label>
                    </td>
                    <td>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.newdisabled}
                            onChange={(e) =>
                              this.setState({
                                newdisabled: !this.state.newdisabled,
                              })
                            }
                          />
                        }
                        label="Disabled"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.8rem",
                          },
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Image</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td
                            style={{
                              width: "100%",
                              display:
                                this.props.editOperation ||
                                  this.state.changingImage
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <img
                              src={
                                this.state.changingImage
                                  ? URL.createObjectURL(this.state.newimage)
                                  : `data:image/svg+xml;base64, ${this.state.newimage}`
                              }
                              alt=""
                              style={{ maxWidth: "60pt" }}
                            />
                          </td>
                          <td>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                this.setState({
                                  newimage: e.target.files[0],
                                  changingImage: true,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Packet Image 1</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td
                            style={{
                              width: "100%",
                              display:
                                this.props.editOperation ||
                                  this.state.changingPacketImage1
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <img
                              src={
                                this.state.changingPacketImage1
                                  ? URL.createObjectURL(this.state.newpacketimage1)
                                  : `data:image/svg+xml;base64, ${this.state.newpacketimage1}`
                              }
                              alt=""
                              style={{ maxWidth: "60pt" }}
                            />
                          </td>
                          <td>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                this.setState({
                                  newpacketimage1: e.target.files[0],
                                  changingPacketImage1: true,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Packet Image 2</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td
                            style={{
                              width: "100%",
                              display:
                                this.props.editOperation ||
                                  this.state.changingPacketImage2
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <img
                              src={
                                this.state.changingPacketImage2
                                  ? URL.createObjectURL(this.state.newpacketimage2)
                                  : `data:image/svg+xml;base64, ${this.state.newpacketimage2}`
                              }
                              alt=""
                              style={{ maxWidth: "60pt" }}
                            />
                          </td>
                          <td>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                this.setState({
                                  newpacketimage2: e.target.files[0],
                                  changingPacketImage2: true,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Packet Image 3</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td
                            style={{
                              width: "100%",
                              display:
                                this.props.editOperation ||
                                  this.state.changingPacketImage3
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <img
                              src={
                                this.state.changingPacketImage3
                                  ? URL.createObjectURL(this.state.newpacketimage3)
                                  : `data:image/svg+xml;base64, ${this.state.newpacketimage3}`
                              }
                              alt=""
                              style={{ maxWidth: "60pt" }}
                            />
                          </td>
                          <td>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                this.setState({
                                  newpacketimage3: e.target.files[0],
                                  changingPacketImage3: true,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
